import Rating from '@material-ui/lab/Rating';

const StarStatus = ({status, size}) => {
  if(status === null){ status = 0 };
  return <Rating name={`size-${size}`} value={status} size={size} readOnly />;
}

export default StarStatus;